/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { cached } from '@glimmer/tracking';
import UiBookingMessagesMessageBaseComponent from 'uplisting-frontend/components/ui/booking/messages/message/-base';
import { MessageStatus } from 'uplisting-frontend/models/message';

export default class UiBookingMessagesMessageOutboundComponent extends UiBookingMessagesMessageBaseComponent {
  @cached
  get isPendingDisplay(): boolean {
    return !this.message.id && this.message.status !== MessageStatus.sent;
  }

  @cached
  get isSaveable(): boolean {
    return !!this.message.content && this.message.isConversation;
  }

  @cached
  get messageFailureTooltipText(): string | undefined {
    if (!this.message.isFailed) {
      return;
    }

    const baseKey = 'action_bookings_messages.messages.message.failure_reasons';

    if (this.intl.exists(`${baseKey}.${this.message.failureReason}`)) {
      return this.intl.t(`${baseKey}.${this.message.failureReason}`);
    }

    return this.intl.t(`${baseKey}.default`);
  }

  @cached
  get statusClass(): string | undefined {
    if (this.message.isFailed) {
      return 'red';
    }

    if (this.message.isPending) {
      return 'opacity-70';
    }
  }

  @cached
  get notificationOverrideMessage(): string | undefined {
    const baseKey =
      'action_bookings_messages.messages.subscription_notification_mappings.outbound';

    if (this.intl.exists(`${baseKey}.${this.message.context}`)) {
      return this.intl.t(`${baseKey}.${this.message.context}`);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ui/booking/messages/message/outbound': typeof UiBookingMessagesMessageOutboundComponent;
    'Ui::Booking::Messages::Message::Outbound': typeof UiBookingMessagesMessageOutboundComponent;
  }
}
